"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StackView = require("../StackView");
var _ViewportProvider = require("../ViewportProvider");
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// pass through and type relevant system props - add more sets for interactive components
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
const isQuickListItem = element => {
  const elementName = element?.type?.displayName || element?.type?.name;
  return Boolean(elementName.match(/QuickLinksFeatureItem/));
};

/**
 * QuickLinksFeature renders a list of interactive items.
 *  - This is the base component that is used as a wrapper and accepts a List of `QuickLinksFeature.Item`
 */
const QuickLinksFeature = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    tokens,
    variant,
    tag = 'ul',
    children,
    ...rest
  } = _ref;
  const viewport = (0, _ViewportProvider.useViewport)();
  const {
    stackGap,
    stackJustify,
    stackSpace
  } = (0, _ThemeProvider.useThemeTokens)('QuickLinksFeature', tokens, variant, {
    viewport
  });
  const items = _react.default.Children.map(children, child => {
    if (isQuickListItem(child)) {
      return /*#__PURE__*/_react.default.cloneElement(child, child.props);
    }
    return null;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_StackView.StackWrap, {
    space: stackSpace,
    gap: stackGap,
    tokens: {
      justifyContent: stackJustify
    },
    tag: tag,
    ref: ref,
    ...selectProps(rest),
    children: items
  });
});
QuickLinksFeature.displayName = 'QuickLinksFeature';
QuickLinksFeature.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _utils.getTokensPropType)('QuickLinksFeature'),
  variant: _utils.variantProp.propType,
  /**
   * Default wrapper tag, by default it's "ul"
   */
  tag: _propTypes.default.string,
  /**
   * QuickLinksFeature.Item component
   */
  children: _propTypes.default.node
};
var _default = exports.default = QuickLinksFeature;